import React from 'react';
import { Pen, Type, TextCursor, Calendar, CheckSquare } from 'lucide-react';
import { FIELD_TYPE_LIST } from './utils/fieldTypes';

// Map field type icons
const ICON_MAP = {
  Pen: Pen,
  Type: Type,
  TextCursor: TextCursor,
  Calendar: Calendar,
  CheckSquare: CheckSquare,
};

const FieldPalette = ({
  onDragStart,
  selectedToolType = null,
  onToolSelect,
  disabled = false
}) => {
  const handleClick = (fieldTypeId) => {
    if (disabled || !onToolSelect) return;
    // Toggle selection - click again to deselect
    onToolSelect(selectedToolType === fieldTypeId ? null : fieldTypeId);
  };

  return (
    <div className="bg-white rounded-lg border border-gray-200 p-4">
      <h3 className="text-sm font-semibold text-gray-700 mb-3">Fields</h3>
      <p className="text-xs text-gray-500 mb-4">
        Drag or click to select, then click on document
      </p>

      <div className="space-y-2">
        {FIELD_TYPE_LIST.map((fieldType) => {
          const Icon = ICON_MAP[fieldType.icon] || TextCursor;
          const isSelected = selectedToolType === fieldType.id;

          return (
            <div
              key={fieldType.id}
              draggable={!disabled}
              onDragStart={(e) => onDragStart(fieldType.id, e)}
              onClick={() => handleClick(fieldType.id)}
              className={`
                flex items-center gap-3 p-3 rounded-lg border-2 transition-all
                ${disabled
                  ? 'opacity-50 cursor-not-allowed border-gray-200 bg-gray-50'
                  : isSelected
                    ? 'cursor-pointer border-blue-500 bg-blue-50 ring-2 ring-blue-200'
                    : 'cursor-pointer hover:border-gray-300 hover:bg-gray-50 border-gray-200'
                }
              `}
              style={{
                borderLeftColor: isSelected ? fieldType.color : fieldType.color,
                borderLeftWidth: '4px',
              }}
            >
              <div
                className="p-2 rounded"
                style={{ backgroundColor: isSelected ? fieldType.color + '30' : fieldType.bgColor }}
              >
                <Icon
                  className="w-4 h-4"
                  style={{ color: fieldType.color }}
                />
              </div>
              <span className={`text-sm font-medium ${isSelected ? 'text-gray-900' : 'text-gray-700'}`}>
                {fieldType.name}
              </span>
              {isSelected && (
                <span className="ml-auto text-xs text-blue-600 font-medium">
                  Click to place
                </span>
              )}
            </div>
          );
        })}
      </div>

      {disabled && (
        <p className="text-xs text-amber-600 mt-4 p-2 bg-amber-50 rounded">
          Upload a PDF to start adding fields
        </p>
      )}
    </div>
  );
};

export default FieldPalette;
